module.exports = __webpack_public_path__ + "img/image (30).8d8af6de.jpg";